import EmailInput from '@active/react-ui/EmailInput';
import { isEmail } from '@active/core/email/validate';

const handleEmailValidate = (value) => {
  if (value && !isEmail(value)) {
    return 'react-ui.validation.invalid';
  }
  return '';
};

export default {
  field: {
    name: 'email',
    label: 'checkout.lib.components.common.contact.field.email',
    component: EmailInput,
    required: true,
    maxLength: 255,
    validate: handleEmailValidate,
    autoComplete: 'email',
  },
};
